import React from 'react';
import { translationKeys } from './i18n/en';
import { useTranslation } from 'react-i18next';
import bemBlock from '@gik/core/utils/bemBlock';
import { Button, SvgIcon } from '@gik/ui';
import { openContactPageOrganizersModal } from '../ContactPageOrganizers/ContactPageOrganizers';

export type ContactPageOrganizersForAddressVariant = 'default' | 'interstitial' | 'centered';

export interface IContactPageOrganizersForAddressProps {
  inkindRouteId: string;
  variant?: ContactPageOrganizersForAddressVariant;
}

export default function ContactPageOrganizersForAddress({
  inkindRouteId,
  variant = 'default',
}: IContactPageOrganizersForAddressProps): React.ReactElement {
  const bem = bemBlock('contact-page-organizers-for-address');
  const { t } = useTranslation();
  return (
    <div className={bem(null, [variant])}>
      <div className={bem('description')}>{t(translationKeys.description)}</div>
      <Button
        size="xs"
        uppercase
        pill
        className={bem('button')}
        onClick={() => openContactPageOrganizersModal(inkindRouteId)}
        prepend={<SvgIcon name="Mail" set="hero-icons" size="xs" />}
      >
        {t(translationKeys.emailAnOrganizer)}
      </Button>
    </div>
  );
}
